// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tl-compare-bars {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px;
}

.tl-compare-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tl-compare-panel-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--an-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin: 0 0 4px;
}

.tl-compare-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 3px 6px;
  margin: 0 -6px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.12s ease;
}

.tl-compare-row:hover {
  background: var(--an-surface-hover);
}

.tl-compare-row-active {
  background: var(--an-accent-soft);
}

.tl-compare-row-active .tl-compare-row-label {
  color: var(--an-text);
  font-weight: 700;
}

.tl-compare-row-label {
  flex: 0 0 60px;
  font-size: 13px;
  color: var(--an-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tl-compare-track {
  flex: 1 1;
  height: 10px;
  background: var(--an-border-soft);
  border-radius: 6px;
  overflow: hidden;
}

.tl-compare-fill {
  height: 100%;
  border-radius: 6px;
  transition: width 0.2s ease;
}

.tl-compare-track-bar {
  height: 100%;
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  transition: width 0.2s ease;
}

.tl-compare-fill-within {
  height: 100%;
  background: var(--an-good);
}

.tl-compare-fill-outside {
  height: 100%;
  background: var(--an-critical);
}

.tl-compare-row-value {
  flex: 0 0 64px;
  text-align: right;
  font-size: 12.5px;
  font-weight: 700;
  color: var(--an-text);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 860px) {
  .tl-compare-bars {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Analytics/charts/TimelinessCompareBars.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".tl-compare-bars {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 32px;\n}\n\n.tl-compare-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.tl-compare-panel-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--an-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin: 0 0 4px;\n}\n\n.tl-compare-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 3px 6px;\n  margin: 0 -6px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.tl-compare-row:hover {\n  background: var(--an-surface-hover);\n}\n\n.tl-compare-row-active {\n  background: var(--an-accent-soft);\n}\n\n.tl-compare-row-active .tl-compare-row-label {\n  color: var(--an-text);\n  font-weight: 700;\n}\n\n.tl-compare-row-label {\n  flex: 0 0 60px;\n  font-size: 13px;\n  color: var(--an-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tl-compare-track {\n  flex: 1;\n  height: 10px;\n  background: var(--an-border-soft);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.tl-compare-fill {\n  height: 100%;\n  border-radius: 6px;\n  transition: width 0.2s ease;\n}\n\n.tl-compare-track-bar {\n  height: 100%;\n  display: flex;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: width 0.2s ease;\n}\n\n.tl-compare-fill-within {\n  height: 100%;\n  background: var(--an-good);\n}\n\n.tl-compare-fill-outside {\n  height: 100%;\n  background: var(--an-critical);\n}\n\n.tl-compare-row-value {\n  flex: 0 0 64px;\n  text-align: right;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--an-text);\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 860px) {\n  .tl-compare-bars {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
